'use client';
import React from 'react';
import { motion } from 'framer-motion';
import { HeadlineTitle } from '../Typography/HeadlineTitle';
import { SublineTitle } from '../Typography/SublineTitle';

interface IPricingHero {}

export const PricingHero: React.FC<IPricingHero> = () => {
    return (
        <section className="relative flex h-max w-full md:h-[250px]">
            <div className="absolute left-0 top-0 h-full w-full" />

            <motion.div
                initial={{ scale: 0, opacity: 0, y: '200px' }}
                animate={{ scale: 1, y: '0', opacity: 1 }}
                transition={{ duration: 0.4, ease: 'easeInOut' }}
                className="felx mx-auto h-full w-full max-w-7xl flex-col pt-8 md:pt-32"
            >
                <div className="relative mx-auto flex max-w-5xl flex-col items-center justify-center gap-2 px-12 text-center md:gap-4">
                    <HeadlineTitle>
                        <span>SaaS Pricing</span>
                    </HeadlineTitle>

                    <SublineTitle>
                        Our SaaS offering is designed to be flexible and scalable to meet your
                        needs. From starter to enterprise, we have a plan that fits your business.
                    </SublineTitle>
                </div>
            </motion.div>
        </section>
    );
};
